import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, Typography, IconButton, Divider } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { IFlyingCart } from "../../../IFlyingCart";
import { useStyle } from "./style";
import { OrderSummaryContent } from "../FlyingCartContent/OrderSummaryContent";
import { ROUTES } from "@constants";

interface IParams {
    flyingCart: IFlyingCart;
}

export const OrderSummaryMobile = (props: IParams) => {
    const { t } = useTranslation("cart");
    const [isExpanded, setIsExpanded] = useState(false);
    const { classes } = useStyle({ isExpanded });
    const history = useHistory();

    const { flyingCart } = props;

    const handleEditClick = () => {
        history.push(ROUTES.CART_PAGE_URL);
    };

    const handleToggleItemsExpanded = useCallback(() => {
        setIsExpanded((prev) => !prev);
    }, []);

    return (
        <Card className={classes.orderSummaryCard} elevation={2}>
            <CardContent>
                <div className={classes.flyingCartHeader}>
                    <Typography className={classes.flyingCartTitle} component="h2" variant="h4">
                        {t("OrderSummary")}
                    </Typography>
                    <IconButton
                        aria-label="Edit cart"
                        className={classes.flyingCartEditButton}
                        onClick={handleEditClick}
                    >
                        <EditIcon />
                    </IconButton>
                </div>
                <Divider className={classes.flyingCartDivider} />
                <OrderSummaryContent
                    flyingCart={flyingCart}
                    isExpanded={isExpanded}
                    onToggleItemsExpanded={handleToggleItemsExpanded}
                />
            </CardContent>
        </Card>
    );
};
